import '../CellItems.scss';

import React from 'react';

import bem from '../../../../../../utils/bem';
import { formatCellMicroCurrency } from '../../../../../../utils/formatting';
import { GreenPlus } from '../../../../../assets';
import { isMoney } from '../../../../utils/changesUtils';
import type { CellItemsProps } from '../DefaultCellItems';

const [block, element] = bem('multiple-change-log-cell');

const UnitCostCell = ({ changes, action }: CellItemsProps): React.JSX.Element => {
  if (Array.isArray(changes) || !isMoney(changes.payload)) return <span>-</span>;

  const { micros, currency } = changes.payload;
  const removalClass = action.removal ? 'removal' : '';

  return (
    <span className={block(removalClass)}>
      {action.addition && <img src={GreenPlus} alt="new-addition-plus-icon" className={element('plus-icon')} />}
      {formatCellMicroCurrency(micros, currency)}
    </span>
  );
};

export default UnitCostCell;
